import React from "react";
import SEO from "@/components/SEO";
import { Link } from "react-router-dom";

const CookiePolicy = () => (
  <div className="heritage-canvas">
    <SEO
      title="Cookie Policy"
      description="Which cookies AfriMarket uses, why, and how to control them."
      path="/cookies"
    />
    <div className="container-narrow py-16 max-w-3xl">
      <div className="label-overline text-[#C05A3C] mb-3">Legal</div>
      <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-3">Cookie Policy</h1>
      <p className="text-sm text-muted-foreground mb-10">
        Last updated: 18 February 2026 · UK PECR compliant
      </p>

      <div className="prose-legal space-y-7 text-[15px] leading-relaxed text-[#1A1A1A]">
        <section>
          <h2 className="font-display text-2xl mt-8 mb-3">What are cookies?</h2>
          <p>
            Cookies are small text files stored on your device when you visit a website. They help the site
            remember your preferences, keep you signed in, and improve your experience. Some are essential;
            others are optional.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl mt-8 mb-3">Cookies we use</h2>

          <div className="mt-4 overflow-x-auto">
            <table className="w-full text-sm border border-black/10 bg-white/60 rounded-md overflow-hidden">
              <thead className="bg-[#F3EFE9] text-left">
                <tr>
                  <th className="px-3 py-2 font-semibold">Cookie</th>
                  <th className="px-3 py-2 font-semibold">Purpose</th>
                  <th className="px-3 py-2 font-semibold">Type</th>
                  <th className="px-3 py-2 font-semibold">Lifetime</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-black/5">
                <tr><td className="px-3 py-2"><code>am_token</code></td><td className="px-3 py-2">Authentication — keeps you signed in.</td><td className="px-3 py-2">Essential</td><td className="px-3 py-2">30 days</td></tr>
                <tr><td className="px-3 py-2"><code>afm_user_location_v1</code></td><td className="px-3 py-2">Stores your &quot;Use my location&quot; geolocation so listings near you load quickly.</td><td className="px-3 py-2">Essential</td><td className="px-3 py-2">15 minutes</td></tr>
                <tr><td className="px-3 py-2"><code>afm_currency</code></td><td className="px-3 py-2">Remembers your selected display currency.</td><td className="px-3 py-2">Essential</td><td className="px-3 py-2">365 days</td></tr>
                <tr><td className="px-3 py-2"><code>afm_cookie_consent</code></td><td className="px-3 py-2">Records your cookie-consent choice so we don&apos;t ask again.</td><td className="px-3 py-2">Essential</td><td className="px-3 py-2">12 months</td></tr>
                <tr><td className="px-3 py-2"><code>stripe-mid</code>, <code>stripe-sid</code></td><td className="px-3 py-2">Fraud prevention set by Stripe during checkout.</td><td className="px-3 py-2">3rd-party essential</td><td className="px-3 py-2">Session – 1 year</td></tr>
                <tr><td className="px-3 py-2"><code>__cf_bm</code></td><td className="px-3 py-2">Cloudflare bot-protection — keeps the site secure.</td><td className="px-3 py-2">3rd-party essential</td><td className="px-3 py-2">30 mins</td></tr>
              </tbody>
            </table>
          </div>

          <p className="mt-6">
            We do not currently use third-party advertising or tracking cookies. If we add analytics or
            advertising cookies in future, we will update this policy and ask for your consent before setting
            them.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl mt-8 mb-3">How to control cookies</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>You can clear or block cookies via your browser settings (Chrome, Safari, Firefox, Edge).</li>
            <li>Blocking essential cookies (e.g. <code>am_token</code>) means you will not be able to sign in.</li>
            <li>Withdrawing consent for non-essential cookies is easy: click &quot;Manage cookies&quot; at the bottom
              of any page.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display text-2xl mt-8 mb-3">More information</h2>
          <p>
            For more about how we handle your data, see our{" "}
            <Link to="/privacy" className="text-[#C05A3C] underline">Privacy Policy</Link> and{" "}
            <Link to="/terms" className="text-[#C05A3C] underline">Terms of Service</Link>.
          </p>
          <p className="text-sm text-muted-foreground mt-6">
            AfriMarket Group Ltd · Company No. 17282940 · Registered in England &amp; Wales.
          </p>
        </section>
      </div>
    </div>
  </div>
);

export default CookiePolicy;
